<script lang="ts" setup>
import { computed } from "vue"
import { useRoute } from "vue-router"
import LoginLayout from "./layouts/login/LoginLayout.vue"
import MainLayout from "./layouts/main/MainLayout.vue"
import PublicLayout from "./layouts/public/PublicLayout.vue"

const route = useRoute()

const layouts = {
  main: MainLayout,
  login: LoginLayout,
  public: PublicLayout
}

const resolveLayout = computed(() => route.meta.requiresAuthorization ? layouts.main : route.meta.layout === "public" ? layouts.public : layouts.login)
</script>

<template>
  <component :is="resolveLayout"></component>
</template>
